// Switcher metadata for the Omni Command shell (EDNA-2005). The portal never
// had a federation entry (it predates the shell contract), so this file plus
// federation-entry.tsx bring it up to the same App + meta shape the other six
// surfaces expose. Shape mirrors OmniRemoteMeta from @omni/objects; the portal
// deliberately keeps zero @omni/* dependencies for now, so the type is
// structural rather than imported.
export const meta = {
  id: 'portal',
  label: 'Portal',
  icon: 'Briefcase',
  basePath: '/portal',
  contextCardSupport: [],
} as const
